/* global Modernizr */

import { Controller } from 'stimulus';

const isMobileNavigation = () => Modernizr.mq('(max-width: 991px)');
const isTouchDevice = () => Modernizr.touchevents;
const KEY_ESCAPE = 27;

class NavigationController extends Controller {
  connect() {
    this.isOpen = false;

    document.addEventListener('keyup', (e) => this.onKeyup(e));
  }

  onTriggerClick() {
    this.isOpen = !this.isOpen;

    this.toggleNavigation();
  }

  onKeyup(event) {
    if (!this.isOpen || event.keyCode !== KEY_ESCAPE || event.key !== 'Escape') return;

    this.isOpen = false;

    this.toggleNavigation();
  }

  onWindowClick({ target }) {
    if (!target.classList.contains('navigation') || target.closest('.navigation__container')) return;

    this.isOpen = false;

    this.toggleNavigation();
  }

  onDropdownTriggerClick(e) {
    const dropdown = document.querySelector(e.target.getAttribute('aria-controls'));
    const isOpen = e.target.getAttribute('aria-expanded') === 'true';
    const toLevel = NavigationController.getLevelForElement(e.target);

    if (!dropdown) {
      return true;
    }

    if (!isMobileNavigation() && isTouchDevice()) {
      e.preventDefault();
      return true;
    }

    if (!isMobileNavigation()) {
      return true;
    }

    if (isMobileNavigation() || isTouchDevice()) {
      e.preventDefault();
    }

    this.closeDropdownAfterLevel(toLevel - 1);
    this.setMainListHeight(dropdown.clientHeight);

    NavigationController.toggleDropdown(dropdown, !isOpen);
    NavigationController.scrollToLevel(this.listTarget, toLevel);

    return true;
  }

  onBackClick(e) {
    e.preventDefault();

    const toLevel = NavigationController.getLevelForElement(e.currentTarget, 'data-level');
    NavigationController.scrollToLevel(this.listTarget, toLevel);
    this.closeDropdownAfterLevel(toLevel);

    this.setMainListHeight(this.listTarget.clientHeight);
  }

  closeDropdownAfterLevel(level) {
    this.dropdownTargets.forEach((dropdown) => {
      const dropdownLevel = NavigationController.getLevelForElement(dropdown);

      if (dropdownLevel > level) {
        NavigationController.toggleDropdown(dropdown, false);
      }
    });
  }

  onCollapsibleListTriggerClick({ currentTarget }) {
    const collapsibleList = document.querySelector(currentTarget.dataset.target);

    $(collapsibleList).on('shown.bs.collapse hidden.bs.collapse', () => {
      const dropdown = currentTarget.closest('.navigation-dropdown');
      const dropdownHeight = dropdown.clientHeight;

      this.setMainListHeight(dropdownHeight);
    });
  }

  toggleNavigation() {
    this.navTarget.classList.toggle('is-open', this.isOpen);
    document.querySelector('body').classList.toggle('nav-is-open', this.isOpen);
  }

  setMainListHeight(height) {
    this.mainListTarget.style.height = `${height}px`;
  }

  static toggleDropdown(dropdown, state) {
    const dropdownId = dropdown.id;
    const toggle = document.querySelector(`[aria-controls="#${dropdownId}"]`);

    if (toggle) {
      toggle.setAttribute('aria-expanded', state);
    }

    dropdown.classList.toggle('is-open', state);
  }

  static getLevelForElement(element, selector = 'data-level') {
    return parseInt(element.getAttribute(selector), 10);
  }

  static scrollToLevel(element, level) {
    const translate = `translateX(-${level * 100}%)`;
    NavigationController.setTransform(element, translate);
  }

  static setTransform(element, transform) {
    element.style.transform = transform;
    element.style.msTransform = transform;
    element.style.webkitTransform = transform;
  }
}

NavigationController.targets = [
  'nav',
  'list',
  'mainList',
  'dropdown',
];

export default NavigationController;
